import {EVENTS} from '../events';
// import RecordRTC  from '../../../node_modules/recordrtc/RecordRTC';
import {RecordRTC}  from 'recordrtc';


/**
 * Video plugin
 */
export class VideoPlugin {
	constructor(chat){
		this.chat = chat;
        this.recorder = null;
	}

	init() {
		const picker = jQuery(BTN_TEMPLATE);

		this.chat.on(EVENTS.WSCHAT_BUILD_FORM_DATA, frmData => this.build_form_data(frmData));

		this.chat.on(EVENTS.WSCHAT_ON_SENT_A_MESSAGE, () => this.reset_files());

		// this.chat.on(EVENTS.WSCHAT_RENDER_CHAT_CONTENT, message => this.format_content(message));
		// this.chat.on(EVENTS.WSCHAT_CAN_SEND_EMPTY_MESSAGE, () => this.files.length > 0);

		this.chat.$el.find('.attachment-wrapper .attachment-list').append(picker);
        this.chat.$el.on('click', '.wschat_video_player_action_start', e => this.start(e));
        this.chat.$el.on('click', '.wschat_video_player_action_stop', e => this.stop(e));
        this.chat.$el.on('click', '.wschat_video_player_action_download', e => this.download(e));

		picker.click(() => this.show_picker());


	}

    build_form_data(frmData) {
        if (this.recorder) {
			frmData.append('attachments[]', this.recorder.getBlob(), 'video.webm');
			frmData.append('rest_from_video_plugin', 'asdf');
        }

        return frmData;
    }

    reset_files() {
        this.video = null;
        this.recorder = null;
        this.chat.$el.find('.wschat_video_form_popup').remove();
    }

	show_picker() {
		const file_input = jQuery(CONFIM_HTML_TEMPLATE);
        this.video_element = file_input.find('video');

		this.chat.$el.find('.wschat_video_form_popup').remove();
		this.chat.$el.find('.chat-panel').after(file_input);

        this.get_stream();
	}

    has_media_device() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            return true;
        }

        return false;
    }

    async get_stream() {

        if (this.has_media_device() === false) {
            this.video_element.before('<p class="text-danger text-center">Camera is not available</p>');
            return;
        }

        const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: true
        });

        this.video_element[0].srcObject = stream;
        this.video_element[0].play();

        this.recorder = RecordRTC(stream, {type: 'video'});
    }

    download() {
        if (! this.recorder) {
            return;
        }

        this.recorder.save();
    }

    start() {
        if (! this.recorder) {
            return;
        }

        this.video_element[0].play();

        this.recorder.startRecording();
        this.info('Recording');
    }

    stop() {
        if (! this.recorder) {
            return;
        }
        this.video_element[0].pause();


        this.recorder.stopRecording(() => {
        	this.info('Stopped');
        });
    }

    info(msg) {
    	this.chat.$el.find('.wschat_video_info').text(msg);
    }
}

export const BTN_TEMPLATE = `
	<button id="wschat_video_picker" class="btn btn-sm attachment-list-item" title="Feedback">
		<i class="material-icons align-bottom">videocam</i>
	</button>
`;

export const CONFIM_HTML_TEMPLATE = `
    <div class="row wschat_video_form_popup p-3 ">
        <div class="col wschat_video_player_wrapper">
            <video muted id="wschat_video_attachment_player"></video>
            <p class="wschat_video_info"></p>
        </div>
        <div class="wschat_video_player_actions">
            <div class="d-flex justify-content-around mt-2">
                <a class="btn btn-sm btn-primary wschat_video_player_action_download" download="video.webm" target="_blank" type="button"><i class="material-icons align-bottom">file_download</i></a>
                <button class="btn btn-sm btn-secondary wschat_video_player_action_stop " type="button"><i class="material-icons align-bottom">stop</i></button>
                <button class="btn btn-sm btn-primary wschat_video_player_action_start" type="button"><i class="material-icons align-bottom">play_arrow</i></button>
            </div>
        </div>
    </div>
`;

